import React from 'react'
import PropTypes from 'prop-types'
import FilterModal from 'components/FilterModal'
import FilterBreadcrumbs from 'components/common/Filters/FilterBreadcrumbs'
import { FilterFacet, FilterGroup } from 'components/common/Filters/FilterGroup'
import CompatibilityForm from '../CompatibilityForm'

const BrandFilterModal = ({
  filters,
  selectedFilters,
  compatibilityFilter,
  hasActiveVehicle,
  handleSubmit,
  handleFilterClear,
  handleFilterRemove,
  handleFilterChange,
  handleCompatibilityChange
}) =>
  <FilterModal onSubmit={ handleSubmit }>
    <FilterBreadcrumbs
      selectedFilters={ selectedFilters }
      onFilterClear={ handleFilterClear }
      onFilterRemove={ handleFilterRemove } />
    {
      filters.map(({ displayName, refinements = []}) =>
        <FilterGroup
          key={ displayName }
          title={ displayName }
          refinements={ refinements }
          onChange={ handleFilterChange } />
      )
    }
    {
      hasActiveVehicle &&
        <FilterFacet title="Compatibility" expandedByDefault={ Boolean(compatibilityFilter) }>
          <CompatibilityForm compatibilityFilter={ compatibilityFilter } handleChange={ handleCompatibilityChange } />
        </FilterFacet>
    }
  </FilterModal>

BrandFilterModal.propTypes = {
  compatibilityFilter: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape()),
  handleCompatibilityChange: PropTypes.func,
  handleFilterChange: PropTypes.func,
  handleFilterClear: PropTypes.func,
  handleFilterRemove: PropTypes.func,
  handleSubmit: PropTypes.func,
  hasActiveVehicle: PropTypes.bool,
  selectedFilters: PropTypes.arrayOf(PropTypes.shape())

}

export default BrandFilterModal
